<template>
    <div class="relative bg-white pt-16 pb-16 sm:pb-32 overflow-hidden" id="tokens">
        <div class="relative">
            <div class="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-10">
                <div class="mt-12 sm:mt-16 lg:mt-0">
                    <div class="pl-4 -mr-48 sm:pl-6 md:-mr-16 lg:px-0 lg:m-0 lg:relative lg:h-full flex justify-center md:mx-auto">
                        <img class="w-1/2 rounded-xl  ring-black ring-opacity-5 lg:absolute lg:left-0 lg:h-full lg:w-auto lg:max-w-none" :src="asset('images/store_phone.png')" alt="Purchasing tokens" />
                    </div>
                </div>
                <div class="px-4 max-w-xl mx-auto sm:px-6 lg:py-16 lg:max-w-none lg:mx-0 lg:px-0">
                    <div>
                        <div>
                            <span class="h-12 w-12 rounded-md flex items-center justify-center bg-gray-800">
                                <DatabaseIcon class="h-6 w-6 text-white" aria-hidden="true" />
                            </span>
                        </div>
                        <div class="mt-6">
                            <h2 class="text-3xl font-extrabold tracking-tight text-gray-900">
                                Stars & Boosters
                            </h2>
                            <p class="mt-4 text-lg text-gray-500">
                                Enhance your gameplay and increase your points with our selection of boosters! Make sure you have enough stars when you need them the most - visit our store page to stock up on Stars Boosters.                            </p>
                            <div class="mt-6">
                                <a href="/register" class="inline-flex px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-gray-800 hover:bg-gray-700">
                                    Sign Up
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import { DatabaseIcon, SparklesIcon } from '@heroicons/vue/outline'

	export default {
		components: {
			DatabaseIcon,
			SparklesIcon,
		}
	}
</script>
